var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"w-5 h-5 flex-shrink-0",style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":_vm.getIconPath(_vm.sportId)},on:{"error":_vm.handleImageError}})
}
var staticRenderFns = []

export { render, staticRenderFns }